<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1wZPqB/tc-custom/9781526788696.jpg?1732165490275" alt="This image is the cover for the book Hurricanes in Action Worldwide!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hurricanes in Action Worldwide!
      </h1>
      <p class="bookDescription body article font2">
        <p>The Hawker Hurricane was the RAF’s most valuable fighter asset in the Second World War, yet even today is relatively under-appreciated by the general public. Yet from the early months of the war it was the single engine fighter most often encountered by the Luftwaffe and during the Battle of Britain it made 80% of the successful interdictions of enemy formations.  As this superbly researched book written by a leading authority on the air war reveals, this was only the start of the Hurricane’s war service. Its reliability and versatility ensured that variants saw action in more war theaters worldwide than any other fighter. Indeed, as the RAF’s Official History recalls ‘Everywhere the Ubiquitous Hurricane was to be seen’.  This book follows the ‘Hurri’ to Russia, Malta, North Africa and as far afield as Burma, Sumatra and Java.  Seaborne versions fought in the Battle of the Atlantic and defended the Mediterranean convoys. In the ground attack role Hurricane fighter bombers made countless sweeps over occupied Europe. Pilots’ first-hand accounts supplement the text.  Readers are left in no doubt as to the massive contribution that the Hurricane made to ultimate victory.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adrian Stewart
      </h2>
      
      <p class="authorDescription body article">Adrian Stewart was educated at Rugby School before taking First Class Honours at Caius College, Cambridge. His previously published works with Pen and Sword Books include: Eighth Army’s Greatest Victories, Early Battles of Eighth Army, They Flew Hurricanes, The Campaigns of Alexander of Tunis 1940-1945, February 1942 – Britain’s Darkest Days, Carriers at War, Six of Monty’s Men and Ten Squadrons of Hurricanes (2015) have all been published by Pen and Sword Books. He lives near Rugby.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Aviation
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d10a7e78